import { defineMessages } from 'react-intl';

export default defineMessages({
  minimize: {
    id: 'frontbucket.cards.dropdownExpander.minimize',
    description: 'Label for dropdown menu to minimize',
    defaultMessage: 'Minimize',
  },
  expand: {
    id: 'frontbucket.cards.dropdownExpander.expand',
    description: 'Label for dropdown menu to expand',
    defaultMessage: 'Expand',
  },
  close: {
    id: 'frontbucket.cards.dropdownExpander.close',
    description: 'Label for closing expander',
    defaultMessage: 'Close',
  },
});
